import React from "react";
import { useSelector } from "react-redux";
import AlertBox from "../../../components/common/AlertBox";
import Loading from "../../../components/common/Loading";
import Footer from "../../../components/home/common/Footer";
import SideBar from "../../../components/home/common/SideBar";
import TopicChoice from "../../../components/home/topics";
import TopicHeader from "../../../components/home/topics/TopicHeader";
import { getError, getStatus } from "../../../redux/slice/userSlice";

const TopicPage = () => {
  const status = useSelector(getStatus);
  const error = useSelector(getError);
  return (
    <div className="sm:p-6 sm:pb-3 p-3 bg-[#FBF9F9] min-h-[100vh] flex-col flex">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type={status} message={error} /> : null}
      <TopicHeader />
      <div className="flex flex-row gap-14 sm:py-10 py-5">
        <div className="sm:block hidden">
          <SideBar />
        </div>
        <TopicChoice />
      </div>
      <Footer />
    </div>
  );
};

export default TopicPage;
